import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/site/Seo";
import { RequestButton } from "../components/site/Blocks";
import { ContactForm } from "../components/forms/ContactForm";

export default function Contact() {
  return (
    <>
      <Seo title="Contact" description="Contact Trusted Leap about a business requirement, joining the expert network, partnerships or privacy requests." path="/contact" />
      <section className="bg-[#F4F6F8]">
        <div className="container-x grid gap-16 py-20 lg:grid-cols-12 lg:py-28">
          <div className="lg:col-span-5">
            <p className="eyebrow">Contact</p>
            <h1 className="h-display mt-6">Start a conversation.</h1>
            <p className="lead mt-8">For general questions, partnerships or privacy requests, send us a message. If you have a specific requirement, the business request form is the fastest route.</p>
            <div className="mt-12 space-y-4">
              <div className="rounded-lg border border-slate-200 bg-white p-6">
                <h2 className="font-display text-lg font-semibold text-[#0B1220]">Need an expert?</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">Submit a structured business request so we can review your requirement.</p>
                <div className="mt-5"><RequestButton className="btn-primary h-11 text-sm" testId="contact-request-expert-button" /></div>
              </div>
              <div className="rounded-lg border border-slate-200 bg-white p-6">
                <h2 className="font-display text-lg font-semibold text-[#0B1220]">Independent professional?</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">Apply to be considered for the Trusted Leap network.</p>
                <Link to="/for-experts#apply" className="link-arrow mt-5" data-testid="contact-join-expert-link">Join as an Expert <ArrowRight className="h-4 w-4" /></Link>
              </div>
            </div>
          </div>
          <div className="rounded-lg border border-slate-200 bg-white p-6 sm:p-10 lg:col-span-7">
            <h2 className="mb-8 font-display text-2xl font-semibold tracking-tight text-[#0B1220]">Send a message</h2>
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
